import { Box, styled, Typography, useMediaQuery, useTheme } from '@mui/material'
import dayjs from 'dayjs'
import { Delivery } from '../../../../types'

const BannerTextContainer = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 4px;
`

const Divider = styled(Box)`
  width: 1px;
  height: 15px;
  background-color: #d2d2d2;
`

type DetailsPageHeaderTypes = {
  delivery?: Delivery
}

export const DetailsPageHeader = ({ delivery }: DetailsPageHeaderTypes) => {
  const theme = useTheme()
  const isMediumScreen = useMediaQuery(theme.breakpoints.down('lg'))

  return (
    <BannerTextContainer
      sx={{
        flexDirection: isMediumScreen ? 'column' : 'row',
        gap: isMediumScreen ? '4px' : '16px',
      }}
    >
      <Typography fontSize="inherit" fontWeight="bold" noWrap>
        NIR Sample Date{' '}
        {dayjs(delivery?.nir?.arrival_date).format('DD.MM.YYYY HH:mm')}
      </Typography>
      {!isMediumScreen && <Divider />}
      <Typography fontSize="inherit" fontWeight="bold" noWrap>
        {delivery?.nir?.nir_number}
      </Typography>
    </BannerTextContainer>
  )
}
